export const LOAD_MEMBERSHIPS_SUCCEEDED = 'LOAD_MEMBERSHIPS_SUCCEEDED';
export const LOAD_MEMBERSHIPS_STARTED = 'LOAD_MEMBERSHIPS_STARTED';
export const LOAD_MEMBERSHIPS_FAILED = 'LOAD_MEMBERSHIPS_FAILED';


export interface LoadMembershipsStartedAction {
  type: typeof LOAD_MEMBERSHIPS_STARTED;
}
export interface LoadMembershipsSuccededAction {
  type: typeof LOAD_MEMBERSHIPS_SUCCEEDED;
  payload: string[];
}
export interface LoadMembershipsFailedAction {
  type: typeof LOAD_MEMBERSHIPS_FAILED;
}


export type MembershipsActionTypes =
  | LoadMembershipsStartedAction
  | LoadMembershipsSuccededAction
  | LoadMembershipsFailedAction

export interface MembershipsState {
  globalMemberships: string[];
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

